import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-blue-700 via-purple-700 to-indigo-800 text-white pt-16 pb-10 mt-20">

      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-12">

        {/* COMPANY */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
       <h2 className="text-4xl font-extrabold text-white drop-shadow-[0_0_25px_rgba(99,102,241,0.8)]">
  MySchool App
</h2>
          <p className="mt-4 opacity-90 leading-relaxed">
            Powerful, secure, AI-driven School ERP system designed to transform
            learning and administration across schools.
          </p>
        </motion.div>

        {/* QUICK LINKS */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <h3 className="text-xl font-bold mb-4">Quick Links</h3>
          <ul className="space-y-3 text-lg">
            <li><Link to="/" className="hover:text-yellow-300 transition">Home</Link></li>
            <li><Link to="/products" className="hover:text-yellow-300 transition">Products</Link></li>
            <li><Link to="/about" className="hover:text-yellow-300 transition">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-yellow-300 transition">Contact</Link></li>
          </ul>
        </motion.div>

        {/* CONTACT INFO */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15 }}
        >
          <h3 className="text-xl font-bold mb-4">Contact Info</h3>

          <ul className="space-y-3">
            <li className="flex items-center gap-3">
              📍 <span>Kilakarai – 623517, Tamil Nadu, India</span>
            </li>
            <li className="flex items-center gap-3">
              📞 <span>9008747991</span>
            </li>
            <li className="flex items-center gap-3">
              📞 <span>9596564910</span>
            </li>
            <li className="flex items-center gap-3">
              ✉️ <span>myschoolapp001@gmail.com</span>
            </li>
          </ul>
        </motion.div>
      </div>

      {/* COPYRIGHT */}
      <div className="mt-14 border-t border-white/20 pt-6 text-center text-sm opacity-80">
        © {new Date().getFullYear()} Navith Pvt Ltd • All Rights Reserved.
      </div>
    </footer>
  );
}